var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("h1", [_vm._v("Järjestön testidata")]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6" }, [
        _c("h2", [_vm._v("Testidatan palautus")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("p", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.hardReset,
                expression: "hardReset"
              }
            ],
            staticClass: "form-check-input",
            attrs: { type: "checkbox", id: "hardResetOption" },
            domProps: {
              checked: Array.isArray(_vm.hardReset)
                ? _vm._i(_vm.hardReset, null) > -1
                : _vm.hardReset
            },
            on: {
              change: function($event) {
                var $$a = _vm.hardReset,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.hardReset = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.hardReset = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.hardReset = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _c("p", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.justDelete,
                expression: "justDelete"
              }
            ],
            staticClass: "form-check-input",
            attrs: { type: "checkbox", id: "justDeleteOption" },
            domProps: {
              checked: Array.isArray(_vm.justDelete)
                ? _vm._i(_vm.justDelete, null) > -1
                : _vm.justDelete
            },
            on: {
              change: function($event) {
                var $$a = _vm.justDelete,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.justDelete = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.justDelete = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.justDelete = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _vm._m(2)
        ]),
        _vm._v(" "),
        _c("p", [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedType,
                  expression: "selectedType"
                }
              ],
              attrs: { id: "types" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedType = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c(
                "option",
                { attrs: { selected: "" }, domProps: { value: null } },
                [_vm._v("Kaikki")]
              ),
              _vm._v(" "),
              _vm._l(_vm.types, function(type) {
                return _c("option", { domProps: { value: type } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.typeDisplayName(type)) +
                      "\n          "
                  )
                ])
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.reset()
              }
            }
          },
          [_vm._v("Palauta")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c("h2", [_vm._v("Datan generointi")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        Voit generoida uutta dataa sample datan pohjalta.\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.baseSample,
                  expression: "baseSample"
                }
              ],
              attrs: { id: "baseSample" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.baseSample = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c(
                "option",
                { attrs: { selected: "" }, domProps: { value: null } },
                [_vm._v("Valitse sample...")]
              ),
              _vm._v(" "),
              _vm._l(_vm.samples, function(sample) {
                return _c(
                  "option",
                  {
                    attrs: { title: sample.name },
                    domProps: { value: sample }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(sample.name) + "\n          "
                    )
                  ]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.purpose,
                expression: "purpose"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              id: "purpose",
              placeholder: "Käyttötarkoitus"
            },
            domProps: { value: _vm.purpose },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.purpose = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.generate()
              }
            }
          },
          [_vm._v("Generoi")]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.errors && _vm.errors.length > 0
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("label", [_vm._v("Resetointi log")]),
            _vm._v(" "),
            _c("table", { staticClass: "table tablerow tasks-table" }, [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.errors, function(error) {
                  return _c("tr", [
                    _c("td", { staticClass: "w-5" }, [
                      _c("pre", { staticStyle: { margin: "5px 5px" } }, [
                        _vm._v(_vm._s(error.id))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", [
                        _c("span", [_c("b", [_vm._v(_vm._s(error.message))])]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(error.stackTrace))])
                      ])
                    ])
                  ])
                }),
                0
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n        Nappia painamalla palautat järjestön testidatat lähtöarvoihin. Lisäksi, voit tehdä järjestölle hard-resetin.\n        "
      ),
      _c("b", [
        _vm._v(
          "Tämä toiminto poistaa kaikki järjestön datat ennen testidatan palautusta."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "form-check-label", attrs: { for: "hardResetOption" } },
      [_c("b", [_vm._v("Tee hard-reset")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "form-check-label", attrs: { for: "justDeleteOption" } },
      [_c("b", [_vm._v("Tee vain poisto")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_c("span", [_vm._v("Id")])]),
        _vm._v(" "),
        _c("th", [_c("span", [_vm._v("Error")])])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }